<template>
  <div>
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>
    </header>
    <div class="top" v-if="!ifUpdate">
      <gao-kao-step :active="2" :newFlag="newFlag" :examType="examType"></gao-kao-step>
    </div>
    <div class="content">
      <div style="display:flex;justify-content:space-between;align-items:center">
        <el-select disabled :value="examLevelType" style="width:130px">
          <el-option v-for="(t, i) in typeList" :label="t.name" :value="t.id" :key="i"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="generateList">重置</el-button>
      </div>
      <div class="card-container">
        <div class="card title">
          <div style="line-height:30px;color:#333;font-size:14px">等级</div>
          <div style="line-height:30px;color:#333" class="score-range">赋分分值:</div>
          <div style="line-height:30px;color:#333" class="per-percent">分段比例:</div>
          <div style="line-height:30px;color:#333" class="total-ratio">累计比例:</div>
        </div>
        <div class="card" v-for="(l, i) in levelList" :key="i">
          <img @click="deleteLevel" v-if="i == levelList.length - 1" class="delete" style="height:14px;width:14px"
            src="~images/delete_white.png" alt />
          <div class="index" :style="{ background: colorList[i] }">{{ indexLabelList[i] }}</div>
          <div class="score-range">
            <el-input min="0" type="number" v-model.number="l.startScore" style="width:50px;text-align:center"
              size="mini"></el-input>
            <span>~</span>
            <el-input min="0" type="number" v-model.number="l.endScore" style="width:50px;text-align:center"
              size="mini"></el-input>
          </div>
          <div class="per-percent">
            <el-input @change="handleRatioChange" type="number" min="0"  v-model.number="l.ratio"
              style="width:116px;text-align:center" size="mini" >
              <template slot="append">%</template>
            </el-input>
          </div>
          <div class="total-ratio">
            <el-input disabled v-model="l.totalRatio" style="width:116px;text-align:center" size="mini">
              <template slot="append">%</template>
            </el-input>
          </div>
        </div>
        <div v-if="levelList.length <= 25" class="card add" @click="addLevel" style="width:116px">
          <div>
            <i class="el-icon-circle-plus"></i>
          </div>
          <div class="text">新增</div>
        </div>
      </div>
    </div>
    <div style="text-align:center;margin-top:40px;padding-bottom:40px">
      <el-button style="padding-left:30px;padding-right:30px" round @click="save" type="primary" size="small"
        :loading="loading">完成</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { addLevelExam, getLevelExam, updateExamLevel } from '@/api/exam/levelExam'
import exam_enum from '@/utils/exam_enum'
import GaoKaoStep from '@/v3/modules/report/views/gaokao/components/GaoKaoStep.vue'

export default {
  data () {
    return {
      ifUpdate: 0,
      loading: false,
      examType: '1',
      examName: '',
      gradeId: '',
      examLevelType: 1,
      examLevelSettingVos: [],
      examLineSettingVos: [],
      levelList: [],
      indexLabelList: [],
      type: 1,
      levelExamId: '',
      initList: [
        [
          {
            index: 0,
            startScore: 100,
            endScore: 86,
            ratio: 15,
            totalRatio: 15
          },
          { index: 1, startScore: 85, endScore: 71, ratio: 35, totalRatio: 50 },
          { index: 2, startScore: 70, endScore: 56, ratio: 35, totalRatio: 85 },
          { index: 3, startScore: 55, endScore: 41, ratio: 13, totalRatio: 98 },
          { index: 4, startScore: 40, endScore: 30, ratio: 2, totalRatio: 100 }
        ],
        [
          { index: 0, startScore: 100, endScore: 91, ratio: 3, totalRatio: 3 },
          { index: 1, startScore: 90, endScore: 81, ratio: 7, totalRatio: 10 },
          { index: 2, startScore: 80, endScore: 71, ratio: 16, totalRatio: 26 },
          { index: 3, startScore: 70, endScore: 61, ratio: 24, totalRatio: 50 },
          { index: 4, startScore: 60, endScore: 51, ratio: 24, totalRatio: 74 },
          { index: 5, startScore: 50, endScore: 41, ratio: 16, totalRatio: 90 },
          { index: 6, startScore: 40, endScore: 31, ratio: 7, totalRatio: 97 },
          { index: 7, startScore: 30, endScore: 21, ratio: 3, totalRatio: 100 }
        ],
        [
          { index: 0, startScore: 70, endScore: 70, ratio: 5, totalRatio: 5 },
          { index: 1, startScore: 67, endScore: 67, ratio: 10, totalRatio: 15 },
          { index: 2, startScore: 64, endScore: 64, ratio: 10, totalRatio: 25 },
          { index: 3, startScore: 61, endScore: 61, ratio: 10, totalRatio: 35 },
          { index: 4, startScore: 58, endScore: 58, ratio: 10, totalRatio: 45 },
          { index: 5, startScore: 55, endScore: 55, ratio: 10, totalRatio: 55 },
          { index: 6, startScore: 52, endScore: 52, ratio: 10, totalRatio: 65 },
          { index: 7, startScore: 49, endScore: 49, ratio: 10, totalRatio: 75 },
          { index: 8, startScore: 46, endScore: 46, ratio: 10, totalRatio: 85 },
          { index: 9, startScore: 43, endScore: 43, ratio: 10, totalRatio: 95 },
          { index: 10, startScore: 40, endScore: 40, ratio: 5, totalRatio: 100 }
        ],
        [
          { index: 0, startScore: 100, endScore: 100, ratio: 1, totalRatio: 1 },
          { index: 1, startScore: 97, endScore: 97, ratio: 2, totalRatio: 3 },
          { index: 2, startScore: 94, endScore: 94, ratio: 3, totalRatio: 6 },
          { index: 3, startScore: 91, endScore: 91, ratio: 4, totalRatio: 10 },
          { index: 4, startScore: 88, endScore: 88, ratio: 5, totalRatio: 15 },
          { index: 5, startScore: 85, endScore: 85, ratio: 6, totalRatio: 21 },
          { index: 6, startScore: 82, endScore: 82, ratio: 7, totalRatio: 28 },
          { index: 7, startScore: 79, endScore: 79, ratio: 8, totalRatio: 36 },
          { index: 8, startScore: 76, endScore: 76, ratio: 7, totalRatio: 43 },
          { index: 9, startScore: 73, endScore: 73, ratio: 7, totalRatio: 50 },
          { index: 10, startScore: 70, endScore: 70, ratio: 7, totalRatio: 57 },
          { index: 11, startScore: 67, endScore: 67, ratio: 7, totalRatio: 64 },
          { index: 12, startScore: 64, endScore: 64, ratio: 7, totalRatio: 71 },
          { index: 13, startScore: 61, endScore: 61, ratio: 7, totalRatio: 78 },
          { index: 14, startScore: 58, endScore: 58, ratio: 6, totalRatio: 84 },
          { index: 15, startScore: 55, endScore: 55, ratio: 5, totalRatio: 89 },
          { index: 16, startScore: 52, endScore: 52, ratio: 4, totalRatio: 93 },
          { index: 17, startScore: 49, endScore: 49, ratio: 3, totalRatio: 96 },
          { index: 18, startScore: 46, endScore: 46, ratio: 2, totalRatio: 98 },
          { index: 19, startScore: 43, endScore: 43, ratio: 1, totalRatio: 99 },
          { index: 20, startScore: 40, endScore: 40, ratio: 1, totalRatio: 100 }
        ]
      ],
      colorList: [
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A',
        '#05CAAE',
        '#F5BE2B',
        '#46B9FB',
        '#FF656A'
      ],
      letterList: [
        [
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z'
        ],
        [
          'A',
          'B+',
          'B',
          'C+',
          'C',
          'D+',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z'
        ],
        [
          'A+',
          'A',
          'B+',
          'B',
          'B-',
          'C+',
          'C',
          'C-',
          'D+',
          'D',
          'E',
          'F',
          'G',
          'H',
          'I',
          'J',
          'K',
          'L',
          'M',
          'N',
          'O',
          'P',
          'Q',
          'R',
          'S',
          'T',
          'U',
          'V',
          'W',
          'X',
          'Y',
          'Z'
        ],
        [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26
        ]
      ],
      examName: '',
      gradeId: '',
      gradeList: [],
      typeList: [
        {
          id: 1,
          name: '5档赋分'
        },
        {
          id: 2,
          name: '8档赋分'
        },
        {
          id: 3,
          name: '11档赋分'
        },
        {
          id: 4,
          name: '21档赋分'
        }
      ],
      newFlag: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo'
    })
  },
  methods: {
    async getExam () {
      const res = await getLevelExam(this.levelExamId)
      if (res.success) {
        this.gradeId = res.body.gradeId
        this.examName = res.body.examName
        this.examType = res.body.type + ''
        this.lastQuery = res.body
        this.convertExamLineType()
        this.generateOldList(res.body.levelExamLevelSettingVos)
      } else {
        this.$message.error(res.message)
      }
    },
    async save () {
      const examLevelSettingVos = this.levelList.map((exam, i) => {
        exam.name = this.letterList[this.examLevelType - 1][i]
        exam.type = exam_enum.getKeyByValue(this.examLevelType, 'examLevelType'),
          exam.orderNum = i
        return exam
      })
      const valid = this.checkRules(examLevelSettingVos)
      if (!valid) return

      const query = this.lastQuery || this.$route.query
      const { examLineType, firstLine, secondLine, artExamLineType, artFirstLine, artSecondLine } = query
      const form = {
        levelExamLevelSettingVos: examLevelSettingVos,
        levelExamLineSettingVos: this.examLineSettingVos,
        createId: this.userInfo.userId,
        examLevelType: exam_enum.getKeyByValue(this.examLevelType, 'examLevelType'),
        examName: this.examName,
        examType: exam_enum.getKeyByValue(Number(this.examType), 'gaokaoArea'),
        gradeId: this.gradeId,
        schoolId: this.userInfo.schoolId,
        organizationId: this.userInfo.schoolId,
        levelExamId: this.levelExamId,
        firstLine,
        secondLine,
        examLineType,
        artExamLineType,
        artFirstLine,
        artSecondLine,
        newFlag: this.newFlag // 标识新版
      }

      this.loading = true
      let res
      if (this.ifUpdate) {
        res = await updateExamLevel(form)
      } else {
        res = await addLevelExam(form)
      }
      this.loading = false
      if (res.success) {
        sessionStorage.removeItem('XGKsetting')
        this.$message.success('保存成功')
      } else {
        this.$message.error(res.message)
      }
      this.$router.replace('/exam/gaokao')
    },
    checkRules (examLevelSettingVos) {
      let ifValid = true
      const ifNull = true
      let total = 0
      examLevelSettingVos.map((e, i, arr) => {
        // 空或小于0或开始小于结束
        if (
          e.startScore === '' ||
          e.endScore === '' ||
          e.ratio === '' ||
          e.ratio < 0 ||
          e.startScore < e.endScore
        ) {
          ifValid = false
        }
        // 非负整数
        if (!this.isValidNumber(e.startScore) || !this.isValidNumber(e.endScore) || !this.isValidNumber(e.ratio)) {
          ifValid = false
        }
        // 前后差1
        if (i < arr.length - 1) {
          if (e.endScore < arr[i + 1].startScore) {
            ifValid = false
          }
        }
        // 累计100
        total += Number(e.ratio)
      })
      if (!ifValid) {
        this.$message.warning('分值或比例设置有误,请检查是否为正整数,是否为空,是否开始小于结束,是否前后差1,是否累计100')
        return false
      }
      if (total != 100) {
        this.$message.warning('分段比例之和必须等于100%')
        return false
      }
      if (examLevelSettingVos[0].startScore > 100) {
        this.$message.warning('分段比例不能超过100%')
        return false
      }
      return true
    },
    isValidNumber (value) {
      return /^[0-9]+$/.test(value)
    },
    generateOldList (levelExamLevelVos) {
      this.indexLabelList = this.letterList[Number(this.examLevelType) - 1]
      this.levelList = levelExamLevelVos.map((exam, i) => {
        return {
          index: exam.orderNum,
          startScore: exam.startScore,
          endScore: exam.endScore,
          ratio: exam.ratio,
          totalRatio: exam.totalRatio
        }
      })
    },
    generateList () {
      const initList = JSON.parse(JSON.stringify(this.initList))
      const letterList = JSON.parse(JSON.stringify(this.letterList))
      this.levelList = initList[Number(this.examLevelType) - 1]
      this.indexLabelList = letterList[Number(this.examLevelType) - 1]
    },
    deleteLevel () {
      this.levelList.pop()
    },
    addLevel () {
      this.levelList.push({
        index: this.levelList.length,
        startScore: '',
        endScore: '',
        ratio: '',
        totalRatio: ''
      })
    },
    handleRatioChange () {
      this.levelList = this.levelList.map((l, i, arr) => {
        if (i > 0) {
          l.totalRatio = Number(arr[i - 1].totalRatio) + Number(l.ratio)
        } else {
          l.totalRatio = Number(l.ratio)
        }
        return l
      })
    },
    convertExamLineType () {
      if (this.examType + '' == '1') {
        this.examLevelType = 1
      } else if (['2', '5', '6'].indexOf(this.examType + '') > -1) {
        this.examLevelType = 4
      } else if (this.examType + '' == '3') {
        this.examLevelType = 3
      } else if (this.examType + '' == '4') {
        this.examLevelType = 2
      }
    }
  },
  mounted () {
    const query = this.$route.query
    this.examType = query.examType + ''
    this.convertExamLineType()
    this.examName = query.examName
    this.gradeId = query.gradeId
    this.levelExamId = query.levelExamId
    this.ifUpdate = query.update ? 1 : 0
    this.newFlag = query.newFlag + '' === 'true'
    if (this.ifUpdate) {
      this.getExam()
    } else {
      this.examLineSettingVos = JSON.parse(sessionStorage.getItem('XGKsetting')).examLineSettingVos
      this.generateList()
    }
  },
  components: {
    GaoKaoStep
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #999999;

  .back {
    padding-right: 10px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -3px;
    }

    &:hover span {
      color: $color-theme;
    }
  }
}

.top {
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 6px;
  padding: 15px;

  .label {
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 29px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    margin-bottom: 10px;
  }
}

.content {
  background: rgba(255, 255, 255, 1);
  padding: 10px 30px;
  margin-top: 10px;
  border-radius: 6px;

  .card-container {
    margin-top: 20px;
    padding-left: 120px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
    width: calc(100% - 120px);

    .title {
      position: absolute !important;
      left: 0;
      top: 0;
      margin-left: 0 !important;
      width: 100px !important;
      box-shadow: none !important;
    }

    .card {
      padding: 10px 14px 14px;
      position: relative;
      margin-left: 15px;
      height: 186px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 20px rgba(153, 153, 153, 0.18);
      opacity: 1;
      text-align: center;
      border-radius: 4px;
      margin-bottom: 20px;

      .delete {
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
      }

      .index {
        width: 30px;
        height: 30px;
        background: rgba(245, 190, 43, 1);
        border-radius: 50%;
        opacity: 1;
        margin: auto;
        line-height: 30px;
        font-weight: 400;
        font-size: 14px;
        color: #fff;
      }

      .score-range {
        margin-top: 20px;
        font-size: 14px;
        color: #666;
      }

      .per-percent {
        margin-top: 20px;
        font-size: 14px;
        color: #666;
      }

      .total-ratio {
        margin-top: 20px;
        font-size: 14px;
        color: #666;
      }

      ::v-deep .el-input__inner {
        text-align: center;
        padding-right: 1px !important;
        padding-left: 5px !important;
      }

      ::v-deep .el-input-group__append,
      ::v-deep .el-input-group__prepend {
        padding: 0 6px !important;
      }
    }

    .add {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $color-theme;
      transition: all 0.3s linear;
      cursor: pointer;

      &:hover {
        transform: translateY(-5px);
      }

      .text {
        margin-top: 7px;
      }

      i {
        font-size: 40px;
      }
    }
  }
}
</style>
